// extracted by mini-css-extract-plugin
export default {"Complete":"Complete_Complete__mKZxg"};